export default __webpack_public_path__ + "static/media/arrow-red-left.f42ace76.svg";